.container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  flex: 1;
  min-width: 0;
  height:100%;
  overflow:hidden;
}

.productListBox {
  max-width: none;
  padding: 0;
  height: 100%;
  overflow-y: auto;
}

.resultsArea {
  width: 100%;
  margin: 0;
  align-items: center;
  background-color: var(--static-background-standard);
  border-radius: 0.5rem;
  border: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
}

.emptyBox {
  margin: 0;
  padding: 6rem;
  align-items: center;
  gap: 1.5rem;
  background-color: var(--static-background-standard);
  border-radius: 0.5rem;
  border: 1px solid var(--static-divider-standard, rgba(0, 0, 0, 0.12));
}

.searchInput {
  flex-shrink: 5;
}

.searchInput:hover {
  background-color: var(--static-background-strong) !important;
}

.fbaListingFlowLinkSection {
  padding: 1.25rem
}
